import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfigurationModel } from 'src/app/models/configuration';
import { coverageDTO } from 'src/app/models/coverageDTO';
import { NavaidDTOCalculation, NavaidModel, NavaidSitingToolModel } from 'src/app/models/navaid';
import { PerformanceAnalysisDTO } from 'src/app/models/performanceAnalysisDTO';
import { PerformanceDTO } from 'src/app/models/performanceDTO';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PerformanceReportService } from 'src/app/services/performance-report-service';
import { PointsService } from 'src/app/services/points.service';
import { SitingToolService } from 'src/app/services/siting-tool-service.service';
import { TabsService } from 'src/app/services/tabsService';
import { UtilsService } from 'src/app/services/utils.service';
import { PopupPerformanceAnalysisComponent } from '../calculations/performance-analysis/performance-analysis.component';
import { ProcedureVerticalProfileComponent } from '../calculations/procedure-vertical-profile/procedure-vertical-profile.component';
import { Geometry } from 'ol/geom';
import { Feature } from 'ol';
import { NavaidAntennaModelAssociationComponent } from '../navaid-antenna-model-association/navaid-antenna-model-association.component';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { GroundStationsService } from 'src/app/services/ground-stations.service';

@Component({
  selector: 'app-validation-modal',
  templateUrl: './validation-modal.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ValidationModalComponent {

  currentCalculationConfig: ConfigurationModel;

  @Input() fixMultiple:boolean = false;
  fomFixMultiple: string = 'TERMINAL_USE';
  status: boolean = true;

  @Input() terrainElevation: number[];

  @Input() hasMaxAltitude: boolean[];


  @Input() activeIgnored: boolean;
  @Input() activeInvalid: boolean;
  @Input() performanceAnalysisDTO : PerformanceAnalysisDTO;
  @Input() calculationType : string;
  @Input() coverage : coverageDTO;
  @Input() performance : PerformanceDTO;
  @Input() sitingTool : NavaidSitingToolModel;
  @Input() rangeLimitation : string;

  @Input() invalidNavaids : NavaidModel[];
  @Input() ignoredNavaids: NavaidModel[];
  

  @Input() isPublishedElevation: boolean = false;


  constructor(public bsModalRef : BsModalRef, private configService: ConfigurationService,
     public utilsService: UtilsService,
     private calculationService: CalculationsService,
    private pointsController: PointsService,
    private sitingToolService: SitingToolService,
    public popupService: BsModalService,
    public performanceService: PerformanceReportService,
    public http: HttpClient,
    private endpointService: EndpointsService,
    public modalService: ModalControlService,
    private tabsService: TabsService,
    private modalConfirmation: ModalConfirmationService,
    private readonly groundStationsService: GroundStationsService
         ) {
    this.currentCalculationConfig = configService.currentConfiguration;

  }
  

  isNavaidValid(navaid: NavaidModel) {
    if (this.rangeLimitation == 'FOM') {
      return this.utilsService.validFOM(navaid.arinc424fom)
    }

    return  (
              !this.isPublishedElevation
              || this.utilsService.validElevation(this.terrainElevation[this.invalidNavaids.indexOf(navaid)] - navaid.antheight, navaid.effectiveHeight)
            )
            && this.utilsService.validDOC(Number(navaid.doc))
            && this.utilsService.validPositiveNumber(navaid.maxaltitude);
    
  }

  selectAllNavaids(){
    this.invalidNavaids.forEach ( nav => {
      nav.isselected = true;
    });
  }

  deSelectAllNavaids(){
    this.invalidNavaids.forEach ( nav => {
      nav.isselected = false;
    });
  }

  fixDocAllNavaids(value: string){
    this.invalidNavaids.forEach( nav => {
      if(nav.isselected){
        nav.doc = value;
      }
    });

    if(this.coverage){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateDocCoverageNavaids(nav.id, value, this.coverage.navaids);
      })
    }
    if(this.performance){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateDocCoverageNavaids(nav.id, value, this.performance.navaids);
      })
    }
    if(this.performanceAnalysisDTO){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateDocCoverageNavaids(nav.id, value, this.performanceAnalysisDTO.navaids);
      })
    }
    if(this.sitingTool){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateDocCoverageNavaids(nav.id, value, this.sitingTool.navaids);
      });
    }

  }

  fixFomAllNavaids(){
    this.invalidNavaids.forEach( nav => {
      if(nav.isselected){
        nav.arinc424fom = this.fomFixMultiple;
      }
    });

    if(this.coverage){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateFomCoverageNavaids(nav.id, this.fomFixMultiple, this.coverage.navaids);
      });
    }
    if(this.performance){
      this.invalidNavaids.filter(el => el.isselected).forEach( nav => {
        this.updateFomCoverageNavaids(nav.id, this.fomFixMultiple, this.performance.navaids);
      })
    }

  }

  updateDocCoverageNavaids(id:string, value:string, list : NavaidDTOCalculation[]) {
    list.find(el => el.dataBaseId == id).doc = parseInt(value);
  }

  // TODO: check if there is another way (more efficient) to check if the element exists on the list.
  updateFomCoverageNavaids(navaid_id:string, value:string, list : NavaidDTOCalculation[]) {
    list.forEach( nav => {
      if (nav.id == navaid_id){
        let values : string[] = this.utilsService.getDocAndAltitude(value);

        if (values.length > 1 && value != '7: NOT INCLUDED' && value != '9: OUT OF SERVICE') {
          nav.doc = parseInt(values[0]);
          nav.maxaltitude = parseInt(values[1]);
        }
      }
    })
  }

  selectNavaidRow(navaid: NavaidModel) : void{
    this.invalidNavaids.forEach ( nav => {
      if(navaid.id == nav.id){
        nav.isselected = !nav.isselected;
      }
    })
  }

  async performCalculation(validateNavaids = true): Promise<void>{
    if (validateNavaids) {
      const invalidNavaids: NavaidModel[] = [];
      for (const navaid of this.invalidNavaids) {
        if (!this.isNavaidValid(navaid)) {
          invalidNavaids.push(navaid);
        }
      }

      if (invalidNavaids.length > 0) {
        this.modalConfirmation.showMesssageConfirmationModal("Invalid Values",
          "Some values are still invalid. Do you wish to continue ignoring invalid NavAids?", "Yes", "No", () => {
            this.removeNavaidsListFromCalculationDTO(invalidNavaids);
            this.performCalculation(false);
        })
        
        return;
      }
    }

    await this.removeGroundStations();
    switch (this.calculationType){
      case "Coverage":
        this.performCoverage();
        break;
      case "Cumulative Coverage":
        this.performCumulativeCoverage();
        break;
      case "Overlap":
        this.calculationService.calculateOverlap(this.coverage);
        break;
      case "Performance":
        this.performPerformance();
        break;
      case "SitingTool":
        this.performSitingTool();
        break;
      case "PERFORMANCE REPORT" :
        this.calculationService.calculateRoutePerformanceReport(this.performanceAnalysisDTO);
        break;
      case "VERTICAL PROFILE" :
        const bsModalRef = this.popupService.show(ProcedureVerticalProfileComponent);
        bsModalRef.content.performanceAnalysisDTO = this.performanceAnalysisDTO;
        break;
      case "PERFORMANCE ANALYSIS":
        const bsModalAnalysis = this.popupService.show(PopupPerformanceAnalysisComponent);
        bsModalAnalysis.content.performanceAnalysisDTO = this.performanceAnalysisDTO;
        break;


    }
    this.bsModalRef.hide();
  }

  async removeGroundStations() {
    let dto;
    if (this.coverage) {
      dto = this.coverage;
    }
    if (this.performance) {
      dto = this.performance
    }
    if (this.sitingTool) {
      dto = this.sitingTool;
    }
    if (this.performanceAnalysisDTO) {
      dto = this.performanceAnalysisDTO;
    }

    const navaidIdsForCalculation = new Set(dto.navaids.map(dtoNav => dtoNav.dataBaseId));
    await this.groundStationsService.removeGroundStationsRequestPromise(this.invalidNavaids.filter(nav => navaidIdsForCalculation.has(nav.id)))
  }


  performCoverage() : void{
    if (this.coverage.useFSPL){
      const bsModalRef : BsModalRef = this.popupService.show(NavaidAntennaModelAssociationComponent);
      bsModalRef.content.coverageDTO = this.coverage;
      bsModalRef.content.calculationType = this.calculationType;
      return;
    }
    this.calculationService.calculateCoverage(this.coverage);
  }

  performCumulativeCoverage() : void{
    this.calculationService.calculateCumulativeCoverage(this.coverage);
  }

  performPerformance() : void {
    this.calculationService.calculatePerformance(this.performance);
  }

  performSitingTool() : void {
    this.sitingToolService.openSitingToolArea(this.sitingTool);
  }
  changeFixMultiple(){
    this.fixMultiple = true;
  }
  async save(): Promise<void>{
    for(let i  = 0; i < this.invalidNavaids.length; i++){
      if(!this.utilsService.validDOC(parseInt(this.invalidNavaids[i].doc)) || this.invalidNavaids[i].maxaltitude == null){
        this.modalService.showMesssageModal("Error", "Invalid NavAids fields");
        return;
      }
    }
    this.invalidNavaids.forEach(nav => {
      let navaidPayload: NavaidModel = this.pointsController.getNavaidPayload(nav);
      this.http.put(
        this.endpointService.apiUrl + '/' + navaidPayload.id,
          navaidPayload,
          this.endpointService.httpOptions
      ).subscribe({
        next: (data) => {
          this.pointsController.deleteNavaidFeaturesFromMap([this.pointsController.createNavaidFeature(navaidPayload)]);
          this.pointsController.addNavaidToMap(navaidPayload);
        },
        error: (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Updating',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal(
            'Error Updating',
            `There was an error updating the NavAids.`
          );
        }

    })
    });

    await this.removeGroundStations();
    this.modalService.showMesssageModal("NavAids Saved","NavAids saved successfully.");

  }
  performCalculationAndSave() :void {
    switch(this.configService.currentConfiguration.calculation.rangeLimitation){
      case "DOC":
        this.invalidNavaids.forEach( elemnt => {
          if (!this.utilsService.validDOC(parseInt(elemnt.doc))){
            this.status = false;
            return;
          }
        });
        if(this.status){
          this.invalidNavaids.forEach( nav => {
            let navaidPayload = this.pointsController.getNavaidPayload(nav);
            this.pointsController.saveNavaid(navaidPayload);
          });
          this.performCalculation();
        }
        break;
      case "FOM":
        this.invalidNavaids.forEach( elemnt => {
          if (!this.utilsService.validFOM(elemnt.arinc424fom)){
            this.status = false;
            return;
          }
        });
        if(this.status){
          this.invalidNavaids.forEach( nav => {
            let navaidPayload = this.pointsController.getNavaidPayload(nav);
            this.pointsController.saveNavaid(navaidPayload);
          });
          this.performCalculation();
        }
        break
      default:
        break;
    }
  }

  fixSelectedNavaidsElevation() {
    for (let i = 0; i < this.invalidNavaids.length; i++) {
      const navaid: NavaidModel = this.invalidNavaids[i];
      if (!navaid.isselected || this.utilsService.validElevation(this.terrainElevation[i] - navaid.antheight, navaid.effectiveHeight)) {
        continue;
      }

      navaid.effectiveHeight = this.terrainElevation[i];
      this.updateNavaidElevationValue(navaid);
    }
  }

  updateNavaidElevationValue(navaid: NavaidModel) {
    if (this.coverage) {
      this.coverage.navaids.find(nav => nav.dataBaseId == navaid.id).effectiveHeight = this.utilsService.feetToMeters(navaid.effectiveHeight);
    }
    if (this.performance) {
      this.performance.navaids.find(nav => nav.dataBaseId == navaid.id).effectiveHeight = this.utilsService.feetToMeters(navaid.effectiveHeight);
    }
    if (this.sitingTool) {
      this.sitingTool.navaids.find(nav => nav.dataBaseId == navaid.id).effectiveHeight = this.utilsService.feetToMeters(navaid.effectiveHeight);
    }
    if (this.performanceAnalysisDTO) {
      this.performanceAnalysisDTO.navaids.find(nav => nav.dataBaseId == navaid.id).effectiveHeight = this.utilsService.feetToMeters(navaid.effectiveHeight);
    }
  }


  removeNavaidsListFromCalculationDTO(navaids: NavaidModel[]) {
    navaids.forEach(navaid => {
      if (this.coverage) {
        this.coverage.navaids = this.coverage.navaids.filter(nav => nav.dataBaseId != navaid.id);
      }
      if (this.performance) {
        this.performance.navaids = this.performance.navaids.filter(nav => nav.dataBaseId != navaid.id);
      }
      if (this.sitingTool) {
        this.sitingTool.navaids = this.sitingTool.navaids.filter(nav => nav.dataBaseId != navaid.id);
      }
      if (this.performanceAnalysisDTO) {
        this.performanceAnalysisDTO.navaids = this.performanceAnalysisDTO.navaids.filter(nav => nav.dataBaseId != navaid.id);
      }
    });
  }


  updateAltitudeValue(navaid: NavaidModel):void{
    if (this.coverage) {
      const navaidCalculation: NavaidDTOCalculation = this.coverage.navaids.find(nav => nav.dataBaseId == navaid.id);
      navaidCalculation.maxaltitude = Number(navaid.maxaltitude);
      navaidCalculation.maxaltitudeMeters = this.utilsService.feetToMeters(navaidCalculation.maxaltitude);
      navaidCalculation.maxOperationalFL = navaidCalculation.maxaltitude / 100;
    }
    if(this.performance){
      const navaidCalculation: NavaidDTOCalculation = this.performance.navaids.find(nav => nav.dataBaseId == navaid.id);
      navaidCalculation.maxaltitude = Number(navaid.maxaltitude);
      navaidCalculation.maxaltitudeMeters = this.utilsService.feetToMeters(navaidCalculation.maxaltitude);
      navaidCalculation.maxOperationalFL = navaidCalculation.maxaltitude / 100;
    }
    if(this.sitingTool){
      const navaidCalculation: NavaidDTOCalculation = this.sitingTool.navaids.find(nav => nav.dataBaseId == navaid.id);
      navaidCalculation.maxaltitude = Number(navaid.maxaltitude);
      navaidCalculation.maxaltitudeMeters = this.utilsService.feetToMeters(navaidCalculation.maxaltitude);
      navaidCalculation.maxOperationalFL = navaidCalculation.maxaltitude / 100;
    }
    if(this.performanceAnalysisDTO){
      const navaidCalculation: NavaidDTOCalculation = this.performanceAnalysisDTO.navaids.find(nav => nav.dataBaseId == navaid.id);
      navaidCalculation.maxaltitude = Number(navaid.maxaltitude);
      navaidCalculation.maxaltitudeMeters = this.utilsService.feetToMeters(navaidCalculation.maxaltitude);
      navaidCalculation.maxOperationalFL = navaidCalculation.maxaltitude / 100;
    }

  }
  updateDocValue(navaid : NavaidModel):void{
    if (this.utilsService.validDOC( parseInt(navaid.doc))){
      if(this.coverage){
        this.coverage.navaids.forEach( nav =>{
          if(nav.dataBaseId == navaid.id){
            nav.doc = parseInt(navaid.doc);
            return;
          }
        });
      }
      if(this.performance){
        this.performance.navaids.forEach( nav =>{
          if(nav.dataBaseId == navaid.id){
            nav.doc = parseInt(navaid.doc);
            return;
          }
        });
      }
      if(this.sitingTool){
        this.sitingTool.navaids.find(nav => nav.dataBaseId == navaid.id).doc = parseInt(navaid.doc);
      }
      if(this.performanceAnalysisDTO){
        this.performanceAnalysisDTO.navaids.forEach( nav =>{
          if(nav.dataBaseId == navaid.id){
            nav.doc = parseInt(navaid.doc);
            return;
          }
        });
      }
    }
  }

  updateFomValue(navaid : NavaidModel):void{
    if (this.utilsService.validFOM(navaid.arinc424fom)){
      if(this.coverage){
      this.coverage.navaids.forEach( nav =>{
        if(nav.dataBaseId == navaid.id){
          let values : string[] = this.utilsService.getDocAndAltitude(navaid.arinc424fom);

          if (values.length > 1 && navaid.arinc424fom != '7: NOT INCLUDED' && navaid.arinc424fom != '9: OUT OF SERVICE') {
            nav.doc = parseInt(values[0]);
            nav.maxaltitude = parseInt(values[1]);
          }
          return;
        }
      });
    }
    if(this.performance){
      this.performance.navaids.forEach( nav =>{
        if(nav.dataBaseId == navaid.id){
          let values : string[] = this.utilsService.getDocAndAltitude(navaid.arinc424fom);

          if (values.length > 1 && navaid.arinc424fom != '7: NOT INCLUDED' && navaid.arinc424fom != '9: OUT OF SERVICE') {
            nav.doc = parseInt(values[0]);
            nav.maxaltitude = parseInt(values[1]);
          }
          return;
        }
      });
    }
    }
  }
  activateIgnored(){
    this.activeIgnored = true;
    this.activeInvalid = false;
    this.fixMultiple = false;
    return false;
  }
  activateInvalid(){
    this.activeIgnored = false;
    this.activeInvalid = true;
    return false;
  }
  cancel():void{
    this.bsModalRef.hide();
  }

}
